'use client';

import styled from 'styled-components';

export const StyledButton = styled.a`
  width: max-content;
  height: auto;
`;
